import {
  CONVERSATION_WARN_AT,
  MAX_CONVERSATION_MESSAGES,
  MESSAGE_STATUS,
} from "./constants";

/**
 * Frontend mirror of mic-backend/src/services/assistantConversations/conversationRules.js.
 *
 * Counted messages are user prompts and assistant replies. Failed sends, draft-card
 * results (`event: true`), tool calls and status updates are not counted.
 */
export function isCountedMessage(message) {
  if (!message || message.event) return false;
  if (message.role !== "user" && message.role !== "assistant") return false;
  return message.status !== MESSAGE_STATUS.FAILED;
}

export function countMessages(messages) {
  return (Array.isArray(messages) ? messages : []).filter(isCountedMessage).length;
}

/** A prompt is allowed only when there is room for it and its reply. */
export function canSendUserMessage(count) {
  return Number(count || 0) + 2 <= MAX_CONVERSATION_MESSAGES;
}

export function getLimitState(count, { serverLimitReached = false } = {}) {
  const n = Math.max(0, Number(count) || 0);
  const limitReached = serverLimitReached || !canSendUserMessage(n);
  return {
    count: n,
    max: MAX_CONVERSATION_MESSAGES,
    remaining: Math.max(0, MAX_CONVERSATION_MESSAGES - n),
    warn: !limitReached && n >= CONVERSATION_WARN_AT,
    limitReached,
  };
}
